import { createContext, PropsWithChildren, useContext } from 'react';

type ReportBlockConfig = { storageNamespace: string };

const ReportBlockConfigCtx = createContext<ReportBlockConfig>({ storageNamespace: '' });

export const ReportBlockConfigProvider = ({ storageNamespace, children }: PropsWithChildren<ReportBlockConfig>) => (
  <ReportBlockConfigCtx.Provider value={{ storageNamespace }}>{children}</ReportBlockConfigCtx.Provider>
);

export const useReportBlockConfig = () => useContext(ReportBlockConfigCtx);
